import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "revenuedeals",
    defaultRoutePath: "/administrations/revenuedeal",
    menuItemScope: "administration",
    menuItemName: "revenuedeals",

    routes: [
        {
            path: "/administrations/revenuedeal",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Wizards.Create,
        },
        {
            path: "duplicate",
            Component: Wizards.Duplicate,
        },
    ],

}

export default Module;
